<!-- THIS IS A TEMPLATE TO COPY AND PASTE -->
<div style="width: 500px; height: 600px;" data-cy="diagnosis-clone-container">
  <div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%;" data-cy="diagnosis-clone-section">
    <div class="section-header" style="flex-basis: 30px;" data-cy="diagnosis-clone-header">
      <div class="section-header-title" data-cy="diagnosis-clone-title">
        Clone - selected diagnosis to
      </div>
      <div style="flex: 1;"></div>
    </div>
    <!--  MAIN AREA-->
    <div class="section-content" style="flex: 1; padding: 8px; overflow-y: auto;" data-cy="diagnosis-clone-content">
      @if (isLoading) {
        <app-tdo-progress-spinner></app-tdo-progress-spinner>
      }
      @if (!isLoading) {
        @if (loadError) {
          <div data-cy="diagnosis-clone-error-state">
            <div>Unable to load diagnosis forms.</div>
            <button (click)="retry()" class="tdo-button" data-cy="diagnosis-clone-retry-button">Retry</button>
          </div>
        } @else if (caseWorkItemList && caseWorkItemList.length > 0) {
          <div #caseList style="flex: 1; overflow-y: auto;" data-cy="diagnosis-clone-case-list">
            @for (model of caseWorkItemList; track model) {
              <div style="font-size: 20px;" data-cy="diagnosis-clone-case-item">
                <div style="flex: 1; padding-left: 5px; padding-top: 5px; text-align: left; flex-basis: 110px; overflow-y: hidden; border-bottom-style: groove;" [matTooltip]="model.Description" data-cy="diagnosis-clone-case-title">{{this.getTitle(model)}}</div>
                <!--CHILDREN-->
                @if (model.dataPatientCaseWorkItems?.length > 0) {
                  @for (child of model.dataPatientCaseWorkItems; track child) {
                    <div data-cy="diagnosis-clone-work-item">
                      @for (childForm of child.dataPatientCaseWorkItemForms ?? []; track childForm) {
                        <div style="font-size: 15px;" data-cy="diagnosis-clone-form-item">
                          <div class="diag-item" (click)="onCaseItemClick(childForm)" (contextmenu)="onEndoDiagnosisContext($event, childForm); false" data-cy="diagnosis-clone-diagnosis-item">
                            <div style="flex: 1; padding-left: 5px; text-align: left; flex-basis: 110px" [ngClass]="{'diag-item-selected': isItemSelected(childForm), 'deselected-item': !isItemSelected(childForm),'diag-source-selected' : isSource(childForm) }" data-cy="diagnosis-clone-item-name">Diagnosis Form - Tooth #{{childForm.Notation}} -  {{getFormStatus(childForm.enumFormCompletionStatusID)}}</div>
                          </div>
                        </div>
                      }
                    </div>
                  }
                }
              </div>
            }
          </div>
        } @else {
          <div data-cy="diagnosis-clone-empty-state">No diagnosis forms found</div>
        }
      }
    </div>
    <!--  FOOTER-->
    <div class="section-footer" style="flex-basis: 46px; padding-top: 6px;" data-cy="diagnosis-clone-footer">
      <div style="flex: 1; margin-right: 6px;"></div>
      <button (click)="onCancelClick()" class="tdo-button tdo-close" style="margin-right: 6px;" data-cy="diagnosis-clone-cancel-button">Cancel</button>
      <button [disabled]="!(selectedForms.length > 0)" (click)="onOkClick()" class="tdo-button tdo-save" style="margin-right: 6px;" data-cy="diagnosis-clone-ok-button">Ok</button>
    </div>
  </div>
</div>
<ng-template #lectureContextMenu let-data>
  <section class="image-context-menu" data-cy="diagnosis-clone-context-menu">
    <div (click)="selectedSource(data)" class="item" data-cy="diagnosis-clone-select-source">select as Source</div>
  </section>
</ng-template>
